import styled from 'styled-components'

export default styled.div`
  background-color: ${({ theme }) => theme.colors.textSubtle};
  height: 1px;
  margin: 0 auto 32px;
  width: 100%;
`
